import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';

const styles = {
  text: {
    alignItems: 'center',
    display: 'flex',
    margin: 0,
  },
}

export default function EditButton({ onClick }) {
  const navigate = useNavigate();
  return (
    <Typography
      color="primary"
      variant="h6"
      sx={styles.text}
      onClick={() => onClick(navigate)}
      // navigate(`/events/update/${id}`)}
    >
      Edit{' '}
      <CreateIcon
        color="primary"
        fontSize="small"
        style={{ marginLeft: '4px' }}
      />
    </Typography>
  );
}

EditButton.propTypes = {
  onClick: PropTypes.func,
};
